function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["href"],
  _excluded2 = ["href"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$entries from "@babel/runtime-corejs3/core-js/object/entries";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import React from "react";
import PropTypes from "prop-types";
var propsToAttributes = function propsToAttributes(props) {
  var _context, _context2;
  return _mapInstanceProperty(_context = _filterInstanceProperty(_context2 = _Object$entries(props)).call(_context2, function (_ref) {
    var _ref9 = _slicedToArray(_ref, 2),
      value = _ref9[1];
    return value;
  })).call(_context, function (_ref2) {
    var _ref10 = _slicedToArray(_ref2, 2),
      key = _ref10[0],
      value = _ref10[1];
    return "".concat(key /* XSS */, "=").concat(_JSON$stringify(value));
  }).join(' ');
};
var sanitizeProps = function sanitizeProps(unsanitizedProps) {
  var href = unsanitizedProps.href,
    props = _objectWithoutProperties(unsanitizedProps, _excluded);
  var sanitizedProps = _objectSpread({}, props);
  if (!sanitizedProps.imagesrcset && !sanitizedProps.imagesizes) {
    /**
     * If imagesrcset and imagesizes is given we don't set an href. That is because it causes browsers
     * with limited support for these attributes (like Safari) to load the `href` which will be wrong
     * in many cases because it doesnt take into account which image is the most appropriate to use
     * based on the device and conditions.
     */
    sanitizedProps.href = href;
  }
  return sanitizedProps;
};
export var createImagePreloadExtractor = function createImagePreloadExtractor() {
  var ref = /*#__PURE__*/React.createRef();
  var links = [];
  ref.current = {
    links: links,
    addLink: function addLink(url, params) {
      links.push([url, params]);
    },
    resetLinks: function resetLinks() {
      _spliceInstanceProperty(links).call(links, 0);
    }
  };
  return {
    getLinkElements: function getLinkElements() {
      return _mapInstanceProperty(links).call(links, function (_ref3) {
        var _ref11 = _slicedToArray(_ref3, 2),
          props = _ref11[1];
        return /*#__PURE__*/React.createElement("link", sanitizeProps(props));
      });
    },
    getLinkTags: function getLinkTags() {
      return _mapInstanceProperty(links).call(links, function (_ref4) {
        var _ref12 = _slicedToArray(_ref4, 2),
          props = _ref12[1];
        return "<link ".concat(propsToAttributes(sanitizeProps(props)), " >");
      }).join('\n');
    },
    ref: ref
  };
};
var PreloadExtractorContext = /*#__PURE__*/React.createContext();

/**
 * Provider necessary to extract preloads from `Picture` and `Img` elements
 *
 * This component should only be used in the server-side or during static site generation
 *
 * Prefer this component when you rather not use `react-helmet`, `react-helmet-async` or `next/head` to extract link tags
 */
export var ImagePreloadExtractorManager = function ImagePreloadExtractorManager(_ref5) {
  var extractor = _ref5.extractor,
    children = _ref5.children;
  return /*#__PURE__*/React.createElement(PreloadExtractorContext.Provider, {
    value: extractor.ref
  }, children);
};
var extractorType = process.env.NODE_ENV !== "production" ? PropTypes.shape({
  ref: PropTypes.shape({})
}) : {};
process.env.NODE_ENV !== "production" ? ImagePreloadExtractorManager.propTypes = {
  /**
   * Result of calling `createImagePreloadExtractor`
   */
  extractor: extractorType,
  children: PropTypes.node
} : void 0;
export var ImagePreloadLinkExtractor = function ImagePreloadLinkExtractor(_ref6) {
  var as = _ref6.as,
    rel = _ref6.rel,
    media = _ref6.media,
    href = _ref6.href,
    imagesrcset = _ref6.imagesrcset,
    imagesizes = _ref6.imagesizes;
  var preloadExtractor = React.useContext(PreloadExtractorContext);
  var isClient = React.useRef(false);
  if (preloadExtractor) {
    if (isClient.current) {
      // eslint-disable-next-line no-console
      console.warn('Preload extractor should only be provided during server side rendering');
    } else {
      preloadExtractor.current.addLink(href, {
        href: href,
        as: as,
        rel: rel,
        media: media,
        imagesrcset: imagesrcset,
        imagesizes: imagesizes
      });
    }
  }
  React.useEffect(function () {
    isClient.current = true;
  }, []);
  return null;
};
var PreloadRendererContext = /*#__PURE__*/React.createContext(function (props) {
  return /*#__PURE__*/React.createElement(ImagePreloadLinkExtractor, props);
});

/**
 * Provider used to override render strategy for preload tags. Prefer this component if you prefer to use `react-helmet`, `react-helmet-async` or `next/head` to extract link tags.
 */
export var ImagePreloadRenderer = function ImagePreloadRenderer(_ref7) {
  var renderPreload = _ref7.renderPreload,
    children = _ref7.children;
  var sanitizedRender = React.useCallback(function (props) {
    return renderPreload(sanitizeProps(props));
  }, [renderPreload]);
  return /*#__PURE__*/React.createElement(PreloadRendererContext.Provider, {
    value: sanitizedRender
  }, children);
};
process.env.NODE_ENV !== "production" ? ImagePreloadRenderer.propTypes = {
  /**
   * Override the default render strategy for image preloads
   */
  renderPreload: PropTypes.func,
  children: PropTypes.node
} : void 0;
export var useImagePreloadRenderer = function useImagePreloadRenderer(givenRenderer) {
  var contextRenderer = React.useContext(PreloadRendererContext);
  return givenRenderer || contextRenderer;
};

/**
 * Preload a given image. Accepts other props accepted by `link[rel="preload"][as="image"]` elements
 */
export var ImagePreload = function ImagePreload(_ref8) {
  var href = _ref8.href,
    props = _objectWithoutProperties(_ref8, _excluded2);
  var renderer = useImagePreloadRenderer( /*
                                          Does not allow customizing renderer.
                                          That wouldn't make sense.
                                          If a user wants "instance level" customization, they should just use their custom
                                          render strategy directly
                                          */);
  return /*#__PURE__*/(
    // Use JSX so that docs pick it up as a component
    React.createElement(React.Fragment, null, renderer(_objectSpread({
      rel: 'preload',
      as: 'image',
      href: href
    }, props)))
  );
};
ImagePreload.propTypes = {
  /**
   * href of image
   */
  href: PropTypes.string
};